import React, { FC } from 'react';
import {
  LuBlocks, LuCaseSensitive, LuGrid3X3, LuLayers, LuBrain, LuX, LuLightbulb, LuWallet,
  LuShoppingCart, LuCoffee, LuHeartPulse, LuSun, LuBookOpen, LuUtensils, LuBus, LuNewspaper,
  LuSmartphone, LuGlobe, LuGamepad2, LuCloud,
} from 'react-icons/lu';
import type { IconType } from 'react-icons';

const map: Record<string, IconType> = {
  blocks: LuBlocks, letters: LuCaseSensitive, grid: LuGrid3X3, cards: LuLayers, brain: LuBrain, x: LuX,
  bulb: LuLightbulb, wallet: LuWallet, cart: LuShoppingCart, coffee: LuCoffee, heart: LuHeartPulse,
  sun: LuSun, book: LuBookOpen, food: LuUtensils, bus: LuBus, news: LuNewspaper,
  phone: LuSmartphone, globe: LuGlobe, gamepad: LuGamepad2, cloud: LuCloud,
};

const AppIcon: FC<{ name: string; size?: number }> = ({ name, size = 24 }) => {
  const Icon = map[name] ?? LuSmartphone;
  return <Icon size={size} aria-hidden="true" />;
};

export default AppIcon;
